import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"bridge-1"},"children":[{"tag":"g","attrs":{"id":"fill1"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M22 21.0004V3H18V21.0004H22Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M2 20.9994V2.99902H6V20.9994H2Z"}}]},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12 7.99927C8 7.99927 6 5.99927 6 5.99927V15.9993H18V5.99927C18 5.99927 16 7.99927 12 7.99927ZM12 7.99927V15.999M22 3V21.0004H18V3H22ZM2 2.99902V20.9994H6V2.99902H2Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Bridge1 = Vue.extend<IconProps>({
  name: 'Bridge1Icon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'bridge-1',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Bridge1;
